export default __webpack_public_path__ + "static/interieur.range-13658929d4a85b3c7e92e78bf80f7906.jpg";